import Banner from "../components/Hero/banner"
import AboutArea from "../components/Hero/aboutArea"

import PrincipleMain from "../components/Hero/heroPrinciples/principleMain"
import PostList from "../components/Hero/heroPosts/heroPostsMain"

const Home =()=>{
return(
    <>
   <Banner/>
   <AboutArea/>
   <PrincipleMain/>
   <PostList/>
   </>
)
}

export default Home